function titleCaseWords(value: string): string {
  return String(value || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((part) => (part ? `${part[0].toUpperCase()}${part.slice(1)}` : part))
    .join(' ');
}

function looksLikeSystemAreaId(value: string): boolean {
  return /^[a-z0-9]+(?:[_-][a-z0-9]+)*$/.test(value) && !/\s/.test(value);
}

export function presentAreaLabel(raw?: string | null): string {
  const value = String(raw || '').trim();
  if (!value) return '';

  const systemPrefixed = /^Zone\s+([a-z0-9]+(?:[_-][a-z0-9]+)*)$/.exec(value);
  if (systemPrefixed?.[1]) {
    return `${titleCaseWords(systemPrefixed[1])} area`;
  }

  if (/area$/i.test(value) || /^zone\s+[A-Z]/.test(value) || /^Zone\s+[A-Z]/.test(value)) {
    return value;
  }

  if (looksLikeSystemAreaId(value)) {
    return `${titleCaseWords(value)} area`;
  }

  return value;
}
